<template>
  <div class="coupon-wrapper">
    <div class="coupon-list clearfix">
      <template v-show="placeCoupons.length">
        <CouponTicket
          v-for="(coupon) in placeCoupons"
          :key="coupon.couponNumber"
          :data="coupon"
          :checked="coupon.checked"
          :checked-able="checkedAble"
          @change="onCouponChange"
        ></CouponTicket>
      </template>
      <template
        v-for="(coupon, couponIdx) in coupons"
      >
        <CouponTicket
          v-if="couponIdx < (display - placeCoupons.length)"
          :key="coupon.couponNumber"
          :data="coupon"
          :checked="coupon.checked"
          :checked-able="checkedAble"
          @change="onCouponChange"
        ></CouponTicket>
      </template>
    </div>
    <div class="more-coupon" v-if="coupons.length > 6" @click="()=>{this.showMore = true}">更多优惠券</div>
    <a-modal
      title="优惠券"
      :visible="showMore"
      @ok="onOk"
      @cancel="onCancel"
      :width="1200"
    >
      <div class="coupon-modal-wrapper">
        <template
          v-for="(coupon) in coupons"
        >
          <CouponTicket
            :key="coupon.couponNumber"
            :data="coupon"
            :checked="coupon.checked"
            :checked-able="checkedAble"
            @change="onCouponChange"
          ></CouponTicket>
        </template>
      </div>
    </a-modal>
  </div>
</template>

<script>
import CouponTicket from './coupon-ticket.vue'
import _ from 'lodash'

export default {
  name: 'CouponGroup',
  data () {
    return {
      showMore: false,
      placeCoupons: [], // 置顶优惠券
      checkedCoupons: [],
      display: 6,
      coupons: []
    }
  },
  props: {
    options: Array,
    selected: String,
    checkedAble: {
      type: Boolean,
      default: true
    }
  },
  created () {
    this.$watch('options', (newValue) => {
      if (newValue && newValue.length) {
        this.coupons = _.map(newValue, (coupon, couponKey) => {
          return Object.assign({}, coupon, { checked: false, key: couponKey })
        })
      } else {
        this.coupons = []
      }
    }, {
      immediate: true
    })
  },
  watch: {
    selected (newValue) {
      // 根据请求结果重新更新选中状态
      const { coupons } = this
      const checkedIdx = _.findIndex(coupons, cpn => {
        return cpn.checked
      })

      if (!newValue && checkedIdx > -1) {
        // 新增失败
        this.coupons.splice(checkedIdx, 1, {
          ...coupons[checkedIdx],
          checked: false
        })

        return
      }

      if (newValue) {
        if (checkedIdx > -1 && coupons[checkedIdx].couponNumber !== newValue) {
          // 替换失败
          this.coupons.splice(checkedIdx, 1, {
            ...coupons[checkedIdx],
            checked: false
          })
        }

        const idx = _.findIndex(coupons, cpn => {
          return cpn.couponNumber === newValue
        })

        if (idx > -1 && !coupons[idx].checked) {
          this.coupons.splice(idx, 1, {
            ...coupons[idx],
            checked: true
          })
        }
      }
    }
  },
  methods: {
    onCouponChange (coupon) {
      this.coupons.forEach((cpn, cpnIdx) => {
        if (cpnIdx !== coupon.key) {
          cpn.checked = false
        }
      })

      coupon.checked = !coupon.checked

      if (!this.showMore) {
        this.changeGroup()
      }
    },
    changeGroup () {
      const checkedCoupons = _.filter(this.coupons, (cpn) => {
        return cpn.checked
      })

      this.checkedCoupons = checkedCoupons

      this.placeCoupons = []

      this.coupons.forEach((cpn) => {
        if (cpn.checked && (cpn.key > this.display - 1)) {
          this.placeCoupons.push(cpn)
        }
      })

      this.$emit('change', checkedCoupons)
    },
    onOk () {
      this.showMore = false

      this.changeGroup()
    },
    onCancel () {
      // 弹窗内取消时，还原原来选中的值
      if (this.checkedCoupons.length) {
        this.checkedCoupons.forEach((checkCpn) => {
          this.coupons.forEach((cpn) => {
            cpn.checked = (cpn.key === checkCpn.key)
          })
        })
      }

      this.showMore = false
    }
  },
  components: {
    CouponTicket
  }
}
</script>

<style lang="less" scoped>
  .coupon-wrapper {
    .coupon-ticket {
      display: inline-block;
      margin: 10px 0;
      margin-right: 6px;

      &:last-of-type {
        margin-right: 0;
      }
    }

    .more-coupon {
      float: right;
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .coupon-modal-wrapper {
    width: 100%;
    height: 338px;
    overflow: auto;

    .coupon-ticket {
      display: inline-block;
      margin: 10px 28px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .coupon-wrapper {
      text-align: center;
    }
  }
</style>
